import React from 'react';

/** Pulsing placeholder block for loading states; size it with className. */
const Skeleton = ({ className = '' }) => (
  <div
    aria-hidden="true"
    data-testid="skeleton"
    className={`animate-pulse rounded-md bg-secondary-200/70 dark:bg-secondary-700 ${className}`}
  />
);

export default Skeleton;
